// extracted by mini-css-extract-plugin
module.exports = {"click":"Payments_click__1yYpx","userPaymentsContainer":"Payments_userPaymentsContainer__1LSWe"};